import Service 		from "./../../Libs/Service";
import Request 		from "./../../Libs/Service.Request";
import Socket		from "./../../Libs/Service.Socket";

import SetupSettings 					from "./../settings/settings.json";

import { Metadata } 					from "./Metadata";
import { User } 						from "./User";

let Server = new Service({

	Name: "Server",

	Libraries: [Request, Socket],

	Events: {

		"Socket Connection Established": function() {

			this.sendToSocket({
				Init: {}
			});

		}

	},

	Actions: {

		'*': function(data, size) {

			console.info(`%c<<< SERVER DATA << ${Math.round(size / 1000)}kb <<`, 'color: #bada55', data);

			setTimeout(() => {

				//Если получен текущий пользователь
				if (Metadata.loaded && User.loaded && !this.loaded) {

					this.loaded = true;

					Broadcast.call("Server Data Loaded");

				}

			}, 10);

		}

	},

	init() {

		this.loaded = false;

		this.timeouts = {};

	},

	connect() {

		if (location.protocol === 'https:') this.connectSocket('wss://' + SetupSettings["domain"] + ':' + SetupSettings["portSSL"]);

		else this.connectSocket('ws://' + SetupSettings["domain"] + ':' + SetupSettings["port"]);

	},

	sendWithTimeout(data, timeoutKey = null, timeout = null, next = null) {

		if (!timeoutKey) timeoutKey = _.keys(data)[0];
		if (!timeout) timeout = 1000;

		clearTimeout(this.timeouts[timeoutKey]);
		this.timeouts[timeoutKey] = setTimeout(() => {

			Server.sendToSocket(data);

			if (next) next();

		}, timeout);

	}

});

//Делаем объект синглтоном чтобы при импортах возвращался тот же самый экземпляр
if (window.Server) Server = window.Server;
else window.Server = Server;

export { Server }
